    import {css, html, OmniElement,} from 'omni-ui';

    class MultipleAlerts extends OmniElement {
        constructor() {
            super();
            this.isAlertOpen = true;
            this.alertStyle = "is-success";
            this.modalType = "single";
            this.currentIndex = 0;
            this.addEventListener('multiplealerts', event => {
                this.messArr =  event.detail.messagesArr;
                this.closeTimeout =  event.detail.options?.closeTimeout;
                if (this.closeTimeout) {
                    setTimeout(() => {
                        this.remove();
                    }, this.closeTimeout)
                }
            })
        }

        static get styles() {
            return [
              super.styles,
              css`
                .modal-background {
                  overflow-y: auto;
                  padding: 5.7rem 0 5.7rem 0;
                  overflow-y: auto !important;
                }
                .modal .modal-content:not(:first-child) {
                  margin-top: 10px;
                }
                .modal .modal-content {
                  width: 580px !important;
                  max-height: 350px !important;
                  top: 50px;
                }
                .modal .is-grouped-space-between {
                  justify-content: space-between !important;
                  align-items: center;
                }
                .modal .count-p {
                  font-size: 14px !important;
                  font-weight: normal;
                  margin-right: 10px;
                }
                .modal .message-body {
                  margin: 15px 40px 15px 40px;
                  padding: 0 !important;
                  opacity: 0.9 !important;
                  overflow: hidden !important;
                  display: flex;
                  flex-direction: column;
                  word-break: break-all;
                }
                .modal .message-body button.retry-button {
                  padding: 0;
                  text-decoration: underline;
                }
                .modal .message-body button.retry-button:hover {
                  text-decoration: none;
                  color: var(--color-primary);
                  background-color: transparent;
                }
                .modal .message-body span:not(:first-child) {
                  margin-top: 12px;
                }
                .modal .view-less span:not(:first-child) {
                    display: none;
                }
                .modal .control {
                    margin-left: auto;
                }
                .modal .message-header .pagination omni-icon {
                    position: relative !important;
                    left: 5px !important;
                    cursor: pointer;
                }
                .modal .message-header p {
                    font-size: 16px;
                } 
                .modal .message-body .carousel {
                    display: flex;
                    transition: transform 0.5s ease-in-out;
                }

                .modal .message-body .carousel .carousel-item {
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    word-break: break-all;
                    min-width: 100%;
                }
              `,
            ];
        }

        static register(name = 'custom-alert') {
            return super.register(name, MultipleAlerts);
        }

        /**
         * The function returns an icon ID based on the input type.
         * @param type - The type parameter is a string that represents the type of icon that needs to be
         * returned. It can have one of the four values: 'info', 'success', 'warning', or 'danger'.
         * @returns The function `iconId` returns a string value that corresponds to the `type` parameter
         * passed to it. The string value is retrieved from an object that maps different `type` values to
         * their corresponding icon IDs.
         */
        iconId(type) {
            return {
                info: 'omni:informative:info',
                success: 'omni:informative:success',
                warning: 'omni:informative:alert',
                danger: 'omni:informative:error',
            }[type];
        }

        /**
         * The function closes a modal either by removing the entire modal or just the content based on the
         * index parameter.
         * @param index - The index parameter is likely an integer value that is used to determine which
         * modal to close. It is probably used to differentiate between multiple modals that may be open at
         * the same time.
         * @param event - The `event` parameter is an object that represents the event that triggered the
         * function. It contains information about the event, such as the type of event, the target element
         * that triggered the event, and any additional data related to the event. In this case, the
         * `event` parameter is used to
         */
        closeModal(index, event) {
            if (index === 0) {
                this.remove();
            } else {
                event.target.closest(".modal-content").remove();
            }
        }

        /**
         * The function handles the retry functionality when the "Retry" button is clicked. It closes the
         * modal and triggers the retry button event.
         * @param index - The index parameter is likely an integer value that is used to determine which
         * modal to close.
         * @param event - The event parameter is an object that represents the event that triggered the
         * function.
         * @param retryBtnEvent - The `retryBtnEvent` parameter is a callback function that is triggered when the
         * "Retry" button is clicked.
         */
        handleRetry(index, event, retryBtnEvent) {
            retryBtnEvent();
            this.closeModal(index, event);
        }

        /**
         * The function handles the next button click event in the carousel. It increments the `currentIndex`
         * value by 1 and updates the carousel to display the next message.
         */
        handleNext = () => {
            this.currentIndex = (this.currentIndex + 1) % this.messArr.length;
            this.requestUpdate();
        };
        
        /**
         * The function handles the previous button click event in the carousel. It decrements the
         * `currentIndex` value by 1 and updates the carousel to display the previous message.
        */ 
        handlePrev = () => {
            this.currentIndex = (this.currentIndex - 1 + this.messArr.length) % this.messArr.length;
            this.requestUpdate();
        };

        /**
         * The function toggles the modal view between single and multiple views. It changes the `modalType`
         * value to either "single" or "multiple" based on the current value.
        */ 
        toggleModalView = () => {
            this.modalType = this.modalType === "single" ? "multiple" : "single";
            this.requestUpdate();
        }

        render() {
            return html`
            <omni-style>
                <!-- Message Type Modal Alert -->
                <div class="modal ${this.isAlertOpen ? 'is-active' : ''}">
                <div class="modal-background">
                ${this.modalType === "single" && this.messArr.length > 1 ? html`
                <div class="modal-content">
                        <article class="message is-${this.messArr[this.currentIndex].options.type}">
                            <div class="message-header">
                                <p>
                                    <omni-icon icon-id=${this.iconId(this.messArr[this.currentIndex].options.type)}></omni-icon>
                                    ${this.messArr[this.currentIndex].title}
                                </p>
                                <div class="pagination">
                                    <span>${this.currentIndex + 1}/${this.messArr.length}</span>
                                    <omni-icon icon-id="omni:interactive:left" @click=${this.handlePrev}></omni-icon>
                                    <omni-icon icon-id="omni:interactive:right" @click=${this.handleNext}></omni-icon>
                                </div>
                            </div>
                            <div class="message-body">
                            <div class="carousel" style="transform: translateX(-${this.currentIndex * 100}%)">
                            ${this.messArr.map((message, index) => html`
                            <div class="carousel-item">
                                ${message.options.type === 'danger' && !message.bodyMsgArr.length ? html`Please contact your administrator or email at <a href="mailto:omnisupport@annalect.com">omnisupport@annalect.com</a>` : message.bodyMsgArr.map(v => html`<span>${v}</span>`)}
                            </div>`
                            )}
                            </div>
                            </div>
                            <div class="message-footer">
                                <div class="field is-grouped">
                                    <div class="retry-button-container">
                                        <button class="tertiary" @click=${this.toggleModalView}>View More</button>
                                    </div>
                                    <div class="control">
                                        ${this.messArr[this.currentIndex].options.type === 'danger' ? html`<button class="tertiary retry-button"
                                        @click=${(event) => this.handleRetry(0, event, this.messArr[this.currentIndex]?.options?.retryBtnEvent)}>${this.messArr[this.currentIndex].options.retryBtnText}</button>` : ''}
                                        <button class="secondary is-${this.messArr[this.currentIndex].options.type}" @click=${(event) => { this.closeModal(0, event);}}>${this.messArr.length > 1 ? "Dismiss All" : "Dismiss"}</button>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>` 
                : html`
                ${this.messArr.map((msgObj, index) =>
                html`
                    <div class="modal-content">
                        <article class="message is-${msgObj.options.type}">
                            <div class="message-header">
                                <p>
                                    <omni-icon icon-id=${this.iconId(msgObj.options.type)}></omni-icon>
                                    ${msgObj.title}
                                </p>
                                ${this.messArr.length > 1 ? html`<p class="count-p">${index + 1}/${this.messArr.length}</p>` : ''}
                            </div>
                            <div class="message-body">
                                ${msgObj.options.type === 'danger' && !msgObj.bodyMsgArr.length ? html`Please contact your administrator or email at <a href="mailto:omnisupport@annalect.com">omnisupport@annalect.com</a>` : msgObj.bodyMsgArr.map(v => html`<span>${v}</span>`)}
                            </div>
                            <div class="message-footer">
                                <div class="field is-grouped">
                                    ${index === 0 && this.messArr.length > 1 ? html`
                                    <div className="retry-button-container">
                                        <button class="tertiary" @click=${this.toggleModalView}>View Less</button>
                                    </div>` : ''}
                                    <div class="control">
                                        ${(msgObj.options.type === 'danger' && index === 0) ? html`<button class="tertiary retry-button"
                                        @click=${(event) => this.handleRetry(index, event, msgObj?.options?.retryBtnEvent)}>${msgObj.options.retryBtnText}</button>` : ''}
                                        <button class="secondary is-${msgObj.options.type}" @click=${(event) => { this.closeModal(index, event);}}>${(index === 0 && this.messArr.length > 1) ? "Dismiss All" : "Dismiss"}</button>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>`)}`}
                </div>
                </div>
            </omni-style>`
        }
    }

    MultipleAlerts.register();

    /**
     * This function creates and dispatches a custom event to display multiple alerts on a web page.
     * @param args - The `args` parameter is a rest parameter that allows the function to accept an
     * arbitrary number of arguments. In this case, it is used to pass multiple alert messages to the
     * `displayMultipleAlerts` function. The spread operator `...args` is used to collect all the
     * arguments passed to the
     */
    export const displayMultipleAlerts = async ({...args}) => {
        const elem = document.createElement('custom-alert');
        document.body.appendChild(elem);
        elem.dispatchEvent(
            new CustomEvent('multiplealerts', {
                detail: args
            })
        );
    }